import { ArrowUpRight } from "lucide-react";
import { Reveal, Overline } from "@/components/Reveal";

const INDUSTRIES = [
  "E-Commerce",
  "FMCG",
  "Retail",
  "Manufacturing",
  "Automotive",
  "Industrial Supply Chains",
];

export default function Industries() {
  return (
    <section id="industries" data-testid="industries-section" className="py-32">
      <div className="mx-auto max-w-[1440px] px-6 md:px-12">
        <div className="grid grid-cols-1 gap-10 lg:grid-cols-12">
          <Reveal className="lg:col-span-4">
            <Overline>Who We Serve</Overline>
            <h2 className="mt-6 font-display text-4xl font-semibold tracking-tighter sm:text-5xl">
              Built for the supply chains that <span className="text-volt">never sleep.</span>
            </h2>
            <p className="mt-6 max-w-sm text-sm leading-relaxed text-smoke">
              From fulfilment centres to factory gates — electric freight tuned to
              the rhythm of your industry.
            </p>
          </Reveal>

          <div className="lg:col-span-8">
            {INDUSTRIES.map((name, i) => (
              <Reveal key={name} delay={i * 0.05}>
                <div
                  data-testid={`industry-row-${i + 1}`}
                  className="group relative flex cursor-default items-center justify-between border-t border-line py-7 transition-[background-color,padding] duration-500 last:border-b hover:bg-ash/70 hover:pl-6"
                >
                  <span className="absolute left-0 top-0 h-full w-[3px] origin-top scale-y-0 bg-volt transition-transform duration-500 ease-out group-hover:scale-y-100" />
                  <span className="font-display text-2xl font-medium tracking-tight transition-colors duration-300 group-hover:text-volt sm:text-3xl lg:text-4xl">
                    {name}
                  </span>
                  <ArrowUpRight className="h-6 w-6 -translate-x-2 translate-y-2 text-volt opacity-0 transition-all duration-300 group-hover:translate-x-0 group-hover:translate-y-0 group-hover:opacity-100" />
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
